module.exports = __webpack_public_path__ + "img/tech-18.e2f0014d.jpg";